import { ICompanyAutocomplete } from 'features/Companies/components/MultiCompanyAutocomplete'

export interface IRolePermission {
  id: string
  name: string
}

export interface IRole {
  id: string
  name: string
  permissions: IRolePermission[]
}

export interface IUserAutocomplete {
  id: string
  firstName: string
  lastName: string
  username: string
}

export interface ICashiersAutocompleteData {
  usersAutocomplete: IUserAutocomplete[]
}

export interface INewUserValues {
  verticals: string[]
  companies: ICompanyAutocomplete[]
  firstName: string
  lastName: string
  username: string
  email?: string
  password?: string
  position: string
  permissionIDs: string[]
  roles: TSFixMe[]
  mfaEnabled: boolean
  passwordExpirationEnabled: boolean
}

export enum EUserType {
  Base = 'base',
  Cashier = 'cashier',
  Crew = 'crew',
  Warehouse = 'warehouse'
}
